import AccordionCustomizableFi from 'atoms/accordion/AccordionCustomizableFi.vue';
import AccordionCustomizableWrapperFi from 'atoms/accordion/AccordionCustomizableWrapperFi.vue';
import AccordionItemFi from 'atoms/accordion-item-fi/AccordionItemFi.vue';
import ArrowIcon from 'atoms/arrow-icon/ArrowIcon.vue';
import AutocompleteTextInputFi from 'atoms/autocomplete-text-input-fi/AutocompleteTextInputFi.vue';
import AvailabilityIndicator from 'atoms/availability-indicator/AvailabilityIndicator.vue';
import AvailabilityStatus from 'atoms/availability-status/AvailabilityStatus.vue';
import BasePriceFi from 'atoms/base-price-fi/BasePriceFi.vue';
import BreadcrumbFi from 'atoms/breadcrumb-fi/BreadcrumbFi.vue';
import BubbledItem from 'atoms/bubbled-item/BubbledItem.vue';
import ButtonFi from 'atoms/button-fi/ButtonFi.vue';
import CarouselSlideFi from 'atoms/carousel-fi/carousel-slide-fi/CarouselSlideFi.vue';
import CarouselFi from 'atoms/carousel-fi/CarouselFi.vue';
import ChangeCustomerEmailFi from 'atoms/change-customer-email-fi/ChangeCustomerEmailFi.vue';
import CloudImageFi from 'atoms/cloud-image-fi/CloudImageFi.vue';
import CountryFlagFi from 'atoms/country-flag-fi/CountryFlagFi.vue';
import DialogModalFi from 'atoms/dialog-modal-fi/DialogModalFi.vue';
import ErrorMessage from 'atoms/error-message/ErrorMessage.vue';
import EventInterceptor from 'atoms/event-interceptor/EventInterceptor.vue';
import FacetListFi from 'atoms/facet-list-fi/FacetListFi.vue';
import HeadlineFi from 'atoms/headline-fi/HeadlineFi.vue';
import IconAttributeItemFi from 'atoms/icon-attribute-item-fi/IconAttributeItemFi.vue';
import IconFi from 'atoms/icon-fi/IconFi.vue';
import LabelFi from 'atoms/label-fi/LabelFi.vue';
import LdJson from 'atoms/ld-json/LdJson.vue';
import LinkFi from 'atoms/link-fi/LinkFi.vue';
import ListItemFi from 'atoms/list-fi/list-item-fi/ListItemFi.vue';
import ListFi from 'atoms/list-fi/ListFi.vue';
import LoadingIndicator from 'atoms/loading-indicator/LoadingIndicator.vue';
import LoadingIndicatorWrapper from 'atoms/loading-indicator/LoadingIndicatorWrapper.vue';
import LogoHeaderFi from 'atoms/logo-header-fi/LogoHeaderFi.vue';
import NoResultsFi from 'atoms/no-results-fi/NoResultsFi.vue';
import PaginationProgressBar from 'atoms/pagination-progress-bar/PaginationProgressBar.vue';
import PlaceholderFi from 'atoms/placeholder-fi/PlaceholderFi.vue';
import PriceSavingsFi from 'atoms/price-savings-fi/PriceSavingsFi.vue';
import PriceSavingsInPercentFi from 'atoms/price-savings-in-percent-fi/PriceSavingsInPercentFi.vue';
import ProductPackageSizeFi from 'atoms/product-package-size-fi/ProductPackageSizeFi.vue';
import ProductPartialsFi from 'atoms/product-partials-fi/ProductPartialsFi.vue';
import QuantityModificationHintFi from 'atoms/quantity-modification-hint-fi/QuantityModificationHintFi.vue';
import RichtextFi from 'atoms/richtext-fi/RichtextFi.vue';
import SelectFi from 'atoms/select-fi/SelectFi.vue';
import SelectInputFi from 'atoms/select-input-fi/SelectInputFi.vue';
import SelectOptionsWrapperFi from 'atoms/select-options-wrapper-fi/SelectOptionsWrapperFi.vue';
import SelectTextInputFi from 'atoms/select-text-input-fi/SelectTextInputFi.vue';
import SlideUpDownFi from 'atoms/slide-up-down-fi/SlideUpDownFi.vue';
import SliderFi from 'atoms/slider-fi/SliderFi.vue';
import SsrCloudImageFi from 'atoms/ssr-cloud-image-fi/SsrCloudImageFi.vue';
import TableFi from 'atoms/table-fi/TableFi.vue';
import TextInputFi from 'atoms/text-input-fi/TextInputFi.vue';
import TextareaFi from 'atoms/textarea-fi/TextareaFi.vue';
import TooltipFi from 'atoms/tooltip-fi/TooltipFi.vue';
import UniversalBox from 'atoms/universal-box/UniversalBox.vue';
import { defineAsyncComponent } from 'vue';

const ButtonFiIcon = defineAsyncComponent(() => import('atoms/button-fi-icon/ButtonFiIcon.vue'));
const ChangePasswordFi = defineAsyncComponent(
  () => import('atoms/change-password-fi/ChangePasswordFi.vue'),
);
const CheckboxFi = defineAsyncComponent(() => import('atoms/checkbox-fi/CheckboxFi.vue'));
const CheckboxGroupFi = defineAsyncComponent(
  () => import('atoms/checkbox-group-fi/CheckboxGroupFi.vue'),
);
const HybrisAddressFi = defineAsyncComponent(
  () => import('atoms/hybris-address-fi/HybrisAddressFi.vue'),
);
const RadioFi = defineAsyncComponent(() => import('atoms/radio-fi/RadioFi.vue'));
const RadioGroupFi = defineAsyncComponent(() => import('atoms/radio-group-fi/RadioGroupFi.vue'));
const RadioGroupWrapperFi = defineAsyncComponent(
  () => import('atoms/radio-group-wrapper-fi/RadioGroupWrapperFi.vue'),
);
const RangeSliderFi = defineAsyncComponent(() => import('atoms/range-slider-fi/RangeSliderFi.vue'));
const CheckboxCustomFi = defineAsyncComponent(
  () => import('atoms/checkbox-custom-fi/CheckboxCustomFi.vue'),
);
const CheckboxWrapperFi = defineAsyncComponent(
  () => import('atoms/checkbox-wrapper-fi/CheckboxWrapperFi.vue'),
);
const PasswordRequirements = defineAsyncComponent(
  () => import('atoms/password-requirements/PasswordRequirements.vue'),
);
const SitecoreIconFi = defineAsyncComponent(
  () => import('atoms/sitecore-icon-fi/SitecoreIconFi.vue'),
);
const FileUploadFi = defineAsyncComponent(() => import('atoms/file-upload-fi/FileUploadFi.vue'));
const SyntaxHighlight = defineAsyncComponent(
  () => import('atoms/syntax-highlight/SyntaxHighlight.vue'),
);
const StyleguideAlert = defineAsyncComponent(
  () => import('atoms/styleguide-alert/StyleguideAlert.vue'),
);
const DatepickerFi = defineAsyncComponent(() => import('atoms/datepicker-fi/DatepickerFi.vue'));
const ToggleFi = defineAsyncComponent(() => import('atoms/toggle-fi/ToggleFi.vue'));
const TooltipInteractiveFi = defineAsyncComponent(
  () => import('atoms/tooltip-interactive-fi/TooltipInteractiveFi.vue'),
);
const HiddenInputFi = defineAsyncComponent(() => import('atoms/hidden-input-fi/HiddenInputFi.vue'));
const CheckboxGroupWrapperFi = defineAsyncComponent(
  () => import('atoms/checkbox-group-wrapper-fi/CheckboxGroupWrapperFi.vue'),
);
const ContextMenuFi = defineAsyncComponent(() => import('atoms/context-menu-fi/ContextMenuFi.vue'));
const SimpleSelectFi = defineAsyncComponent(
  () => import('atoms/simple-select-fi/SimpleSelectFi.vue'),
);
const AccessPrivilegeListFi = defineAsyncComponent(
  () => import('atoms/access-privilege-list-fi/AccessPrivilegeListFi.vue'),
);
const AccessPrivilegesSelectionFi = defineAsyncComponent(
  () => import('atoms/access-privileges-selection-fi/AccessPrivilegesSelectionFi.vue'),
);
const FormatDictFi = defineAsyncComponent(() => import('atoms/format-dict-fi/FormatDictFi.vue'));

const SimpleMultiselectOptionsFi = defineAsyncComponent(
  () => import('atoms/simple-multiselect-options-fi/SimpleMultiselectOptionsFi.vue'),
);

const TimepickerFi = defineAsyncComponent(() => import('atoms/timepicker-fi/TimepickerFi.vue'));

const ProgressBarFi = defineAsyncComponent(() => import('atoms/progress-bar-fi/ProgressBarFi.vue'));

export {
  IconAttributeItemFi,
  AccordionItemFi,
  AccordionCustomizableFi,
  AccordionCustomizableWrapperFi,
  ArrowIcon,
  AutocompleteTextInputFi,
  BasePriceFi,
  BubbledItem,
  ButtonFi,
  ButtonFiIcon,
  ChangeCustomerEmailFi,
  ChangePasswordFi,
  CheckboxFi,
  CheckboxGroupFi,
  CloudImageFi,
  ErrorMessage,
  EventInterceptor,
  LinkFi,
  HeadlineFi,
  HybrisAddressFi,
  RichtextFi,
  ListFi,
  ListItemFi,
  IconFi,
  TimepickerFi,
  ToggleFi,
  TooltipFi,
  TooltipInteractiveFi,
  LoadingIndicator,
  LoadingIndicatorWrapper,
  LogoHeaderFi,
  SelectFi,
  SelectInputFi,
  SelectTextInputFi,
  SelectOptionsWrapperFi,
  SimpleMultiselectOptionsFi,
  SitecoreIconFi,
  SsrCloudImageFi,
  StyleguideAlert,
  SyntaxHighlight,
  FacetListFi,
  TableFi,
  TextInputFi,
  TextareaFi,
  LabelFi,
  LdJson,
  UniversalBox,
  RangeSliderFi,
  SliderFi,
  SlideUpDownFi,
  CarouselFi,
  CarouselSlideFi,
  CountryFlagFi,
  DatepickerFi,
  BreadcrumbFi,
  RadioFi,
  RadioGroupFi,
  RadioGroupWrapperFi,
  CheckboxWrapperFi,
  CheckboxCustomFi,
  FileUploadFi,
  ProductPackageSizeFi,
  ProductPartialsFi,
  QuantityModificationHintFi,
  DialogModalFi,
  HiddenInputFi,
  CheckboxGroupWrapperFi,
  ContextMenuFi,
  SimpleSelectFi,
  AccessPrivilegeListFi,
  AccessPrivilegesSelectionFi,
  AvailabilityIndicator,
  AvailabilityStatus,
  PaginationProgressBar,
  PlaceholderFi,
  PriceSavingsFi,
  PriceSavingsInPercentFi,
  ProgressBarFi,
  FormatDictFi,
  PasswordRequirements,
  NoResultsFi,
};
